import { render, staticRenderFns } from "./StickyList.vue?vue&type=template&id=0c9fb4c4&scoped=true"
import script from "./StickyList.vue?vue&type=script&lang=js"
export * from "./StickyList.vue?vue&type=script&lang=js"
import style0 from "./StickyList.vue?vue&type=style&index=0&id=0c9fb4c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fb4c4",
  null
  
)

export default component.exports